module.exports = __webpack_public_path__ + "static/media/subs_landing_web.07695318.jpg";